import classNames from 'classnames';

import { numberToCurrency } from 'my-utils';

import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

import { faPlus, faTag, faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const rootCss = ({ palette, spacing }) => ({
  '.CLI-lineItem': {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    '& + .CLI-lineItem': { marginTop: spacing(1) },
  },
  '.CLI-lineItem_disabled': { opacity: 0.6 },
  '.CLI-toggleBtn': {
    position: 'absolute',
    right: '100%',
    top: '50%',
    transform: `translate(${spacing(-0.5)}, -50%)`,
  },
  '.CLI-amount': {
    marginLeft: 'auto',
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  '.CLI-lineItem_disabled .CLI-amount': { textDecoration: 'line-through' },
  '.CLI-crossOutAmount': {
    textDecoration: 'line-through',
    color: palette.secondary.main,
  },
});

export default function CheckoutLineItems({ className, paymentDetails, totalsRows = 1 }) {
  return (
    <div className={className} css={rootCss}>
      {paymentDetails.lineItems
        .slice(0, -totalsRows)
        .map(({ amount, caption, crossOutAmount, enabled, highlight, label, loading, onToggleEnabled }, idx) => (
          <div
            key={idx}
            className={classNames('CLI-lineItem', {
              'CLI-lineItem_disabled': onToggleEnabled && !enabled,
            })}
          >
            {onToggleEnabled && (
              <IconButton className="CLI-toggleBtn" onClick={() => onToggleEnabled(!enabled)} size="small">
                <FontAwesomeIcon icon={enabled ? faTrash : faPlus} size="xs" />
              </IconButton>
            )}
            <Typography
              component="span"
              sx={{
                color:
                  amount < 0 ? 'success.main'
                  : highlight ? 'text.primary'
                  : 'text.secondary',
                pr: 2,
              }}
              variant="body1"
            >
              {amount < 0 && (
                <>
                  <FontAwesomeIcon icon={faTag} />{' '}
                </>
              )}
              {loading ?
                <Skeleton variant="text" width={100} />
              : label}
              {caption && (
                <Typography
                  sx={{
                    color: 'inherit',
                    display: 'block',
                    opacity: 0.7,
                    lineHeight: 1,
                  }}
                  variant="caption"
                >
                  {caption}
                </Typography>
              )}
            </Typography>
            <Typography
              className="CLI-amount"
              component="span"
              sx={{ color: amount < 0 ? 'success.main' : 'inherit' }}
              variant={highlight ? 'subtitle1' : 'body1'}
            >
              {!!crossOutAmount && (
                <>
                  <span className="CLI-crossOutAmount">{numberToCurrency(crossOutAmount)}</span>{' '}
                </>
              )}
              {loading ?
                <Skeleton variant="text" width={100} />
              : numberToCurrency(amount, { forceCents: true })}
            </Typography>
          </div>
        ))}
      <Divider sx={{ my: 2 }} />
      {paymentDetails.lineItems.slice(-totalsRows).map(({ amount, label }) => (
        <div key={label} className="CLI-lineItem">
          <Typography component="span" variant="h6">
            {label}
          </Typography>
          <Typography
            className="CLI-amount"
            component="span"
            sx={{
              color: 'text.secondary',
            }}
            variant="body2"
          >
            {`${paymentDetails.currency.toUpperCase()} `}
            <Typography component="span" sx={{ color: 'text.primary' }} variant="h5">
              {numberToCurrency(amount, { forceCents: true })}
            </Typography>
          </Typography>
        </div>
      ))}
    </div>
  );
}
